import clsx from 'clsx';
import { memo } from 'react';

import Timeline from '../../../editorial-timeline';
import { useTicketingOptions } from '../../store';

import { withErrorBoundary } from '@shared/ErrorBoundary';
import { useTranslateFn } from '@shared/Translate';
import { competitionCode } from '@utilities/WindowContext';

import * as styles from './styles.module.scss';

export const KeyDates = () => {
  const t = useTranslateFn();
  const {
    options: { selectedKeyDateItem, keyDatesShowDisclaimer, showAllTitles, disableInteraction, maxVisibleItems },
  } = useTicketingOptions();

  const opt = {
    showDisclaimer: keyDatesShowDisclaimer,
    selectedItem: selectedKeyDateItem,
    showAllTitles: showAllTitles,
    webcontainerName: `${competitionCode?.toUpperCase()}.TICKETING.TIMELINE`,
    disableInteraction,
    maxVisibleItems,
  };

  return (
    <div
      className={clsx(
        styles.ticketingKeydates,
        'pk-container',
        'pk-py--l pk-py-md--xl2',
        'pk-overflow--hidden',
        'pk-bg--primary-01',
        'ticketing-keydates',
      )}
      pk-theme='dark'
    >
      <h2 className='pk-font--comp-bold pk-col pk-col--span-12 pk-text--text-01 pk-font-size--xl pk-font-size-sm--xl2 pk-pl--m pk-pl-lg--0'>
        {t('euro2020_keydates')}
      </h2>
      <div className='pk-col pk-col--span-12 pk-mt-md--xl3 pk-mt--l'>
        <Timeline options={opt} />
      </div>
    </div>
  );
};

export default withErrorBoundary(memo(KeyDates));
